

const examples = {
  "intro_electronics_demo": {
    "accessToken": "playground",
    "project_id": "electronic_intro_lessons_m3",
    "user": {
      "username": "guest",
      "userFrom": "guest",
      "id": "guest"
    },
    "storage": "none",
    "status": "verified",
    "project": {
      "defaultCode": "void setup() {\n  // put your setup code here, to run once:\n}\n\nvoid loop() {\n  // put your main code here, to run repeatedly:\n}\n",
      "dev": "code",
      "documentationUrl": "https://d32lhafmwoak77.cloudfront.net/docs/Intro_Lessons_M3/index.html",
      "editorLanguage": "TR",
      "folderUrl": "https://d32lhafmwoak77.cloudfront.net/blockly/stembox/electronic_intro_lessons_m3/",
      "language": "cpp",
      "name": "electronic_intro_lessons_m3",
      "simulationUrl": "https://d32lhafmwoak77.cloudfront.net/projects/stembox/nd-intro-lessons/index.html?containerless&language=en&arduino&editor_design_mode=simpleelectronics&robot_editor=true&module=Electronics_IntroLessons%23BasicResistor",
      "title": "Simulation",
      "workspace": "/electronic_intro_lessons_m3",
      "workspaceDefaultType": "split"
    },
    "git_address": "none",
    "files": [],
  }

};

const getToken = () => {
  try {
    const path = window.location.pathname.split("/");
    return path[path.length - 1];
  } catch (e) {
    return "";
  }
};

export const isPublicProject = () => {
  try {
    const token = getToken();
    return Object.keys(examples).includes(token);
  } catch (e) {
    return false;
  }
};

export const getPublicProject = () => {
  try {
    const token = getToken();
    return examples[token as keyof typeof examples];
  } catch (e) {
    return null;
  }
};
